module.exports = __webpack_public_path__ + "static/media/TEMPLATE_3.4d69ea8d.webp";